import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../common/components/Dialog';
import { Button } from 'react-bootstrap';
import RefundForm from './RefundForm';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import { withTranslation } from 'react-i18next';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

class RefundDialog extends Component
{
	dialogConfig() {
		const {onCancel, title } = this.props;

		return {
		header: title,
			body: this.renderBody(),
			onHide: onCancel,
			footer: this.renderFooter()
		};
	}

	renderBody() {
		const { onConfirm, cancellationReasonTypes, onReasonChange, initialValues,cancellationReasonType, ...rest } = this.props;
		return <RefundForm onSubmit={onConfirm}
			cancellationReasonTypes={cancellationReasonTypes}
			initialValues={initialValues}
			onReasonChange={onReasonChange}
			cancellationReasonType={cancellationReasonType} {...rest} />;
	}

	renderFooter() {
		const { onCancel, buttonLabel, t } = this.props;

		const closeBtn = <Button key = 'close' onClick ={ onCancel}>{ t('Common_Close')}</Button>;
		const confirmBtn = <RemoteSubmitButton key='refund' style='danger' formName='refundForm'
			label={buttonLabel} icon={faXmark} />
		
		return [closeBtn, confirmBtn];
	}

	render() {
		const { show, block, unblock } = this.props;
		return <Dialog config={this.dialogConfig()}
		show ={show}
		block ={block}
		unblock ={unblock} />;
	}
}

RefundDialog.propTypes = {
show: PropTypes.bool,
block: PropTypes.oneOfType([
	PropTypes.instanceOf(RegExp),
	PropTypes.string,
	PropTypes.array,
	PropTypes.func
]),
	unblock: PropTypes.oneOfType([
		PropTypes.instanceOf(RegExp),
		PropTypes.string,
		PropTypes.array,
		PropTypes.func
	]),
	onCancel: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired
};

export default withTranslation()(RefundDialog);